(() => {
  const drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  const setOpen = (open) => {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.querySelector('[data-drawer-open]')?.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('eb-drawer-open', open);
  };
  document.querySelector('[data-drawer-open]')?.addEventListener('click', () => setOpen(true));
  drawer.querySelectorAll('[data-drawer-close], a').forEach((el) => el.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
})();

document.querySelectorAll('[data-submenu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const submenu = button.nextElementSibling;
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    button.querySelector('[aria-hidden="true"]').textContent = open ? '−' : '＋';
    if (submenu) submenu.hidden = !open;
  });
});

document.querySelectorAll('[data-finder-panel]').forEach((panel) => {
  panel.addEventListener('toggle', () => {
    if (!panel.open) return;
    document.querySelectorAll('[data-finder-panel]').forEach((other) => {
      if (other !== panel) other.open = false;
    });
  });
});

const openFinderFromHash = () => {
  if (!window.location.hash) return;
  const panel = document.querySelector(window.location.hash);
  if (panel?.matches('[data-finder-panel]')) panel.open = true;
};
openFinderFromHash();
window.addEventListener('hashchange', openFinderFromHash);

document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
  const slides = [...slider.querySelectorAll('[data-hero-slide]')];
  const dots = [...slider.querySelectorAll('[data-hero-dot]')];
  const previous = slider.querySelector('[data-hero-prev]');
  const next = slider.querySelector('[data-hero-next]');
  if (slides.length < 2) return;

  let activeIndex = 0;
  let autoplay;
  const showSlide = (index) => {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === activeIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === activeIndex;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };
  const startAutoplay = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.clearInterval(autoplay);
    autoplay = window.setInterval(() => showSlide(activeIndex + 1), 6500);
  };

  dots.forEach((dot, index) => dot.addEventListener('click', () => { showSlide(index); startAutoplay(); }));
  previous?.addEventListener('click', () => { showSlide(activeIndex - 1); startAutoplay(); });
  next?.addEventListener('click', () => { showSlide(activeIndex + 1); startAutoplay(); });
  let touchStartX = 0;
  slider.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
  slider.addEventListener('touchend', (event) => {
    const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
    if (Math.abs(distance) < 45) return;
    showSlide(activeIndex + (distance < 0 ? 1 : -1));
    startAutoplay();
  }, { passive: true });
  slider.addEventListener('mouseenter', () => window.clearInterval(autoplay));
  slider.addEventListener('mouseleave', startAutoplay);
  slider.addEventListener('focusin', () => window.clearInterval(autoplay));
  slider.addEventListener('focusout', startAutoplay);
  startAutoplay();
});

document.querySelectorAll('[data-editorial-slider]').forEach((slider) => {
  const track = slider.querySelector('[data-editorial-track]');
  const slides = [...slider.querySelectorAll('.eb-editorial-slide')];
  const dots = [...slider.querySelectorAll('[data-editorial-dot]')];
  const previous = slider.querySelector('[data-editorial-prev]');
  const next = slider.querySelector('[data-editorial-next]');
  if (!track || slides.length < 2) return;

  let activeIndex = 0;
  let autoplay;
  const setActive = (index) => {
    activeIndex = index;
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      if (dotIndex === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };
  const goTo = (index) => {
    const targetLeft = slides[index].offsetLeft - (track.clientWidth - slides[index].offsetWidth) / 2;
    track.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    setActive(index);
  };
  const startAutoplay = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.clearInterval(autoplay);
    autoplay = window.setInterval(() => goTo((activeIndex + 1) % slides.length), 5500);
  };

  dots.forEach((dot, index) => dot.addEventListener('click', () => { goTo(index); startAutoplay(); }));
  previous?.addEventListener('click', () => { goTo((activeIndex - 1 + slides.length) % slides.length); startAutoplay(); });
  next?.addEventListener('click', () => { goTo((activeIndex + 1) % slides.length); startAutoplay(); });
  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
      const center = track.scrollLeft + track.clientWidth / 2;
      const nearest = slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center) < best.distance ? { index, distance: Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center) } : best, { index: 0, distance: Infinity });
      setActive(nearest.index);
    });
  }, { passive: true });
  slider.addEventListener('mouseenter', () => window.clearInterval(autoplay));
  slider.addEventListener('mouseleave', startAutoplay);
  slider.addEventListener('focusin', () => window.clearInterval(autoplay));
  slider.addEventListener('focusout', startAutoplay);
  startAutoplay();
});

document.querySelectorAll('[data-topics-slider]').forEach((slider) => {
  const tabs = [...slider.querySelectorAll('[data-topics-tab]')];
  const panels = [...slider.querySelectorAll('[data-topics-panel]')];
  const previous = slider.querySelector('[data-topics-prev]');
  const next = slider.querySelector('[data-topics-next]');
  const activeRail = () => slider.querySelector('[data-topics-panel]:not([hidden]) [data-topics-rail]');
  const selectTab = (tab) => {
    tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.topicsPanel !== tab.dataset.topicsTab;
    });
    activeRail()?.scrollTo({ left: 0, behavior: 'instant' });
  };
  const move = (direction) => {
    const rail = activeRail();
    rail?.scrollBy({ left: direction * Math.max(280, rail.clientWidth / 3), behavior: 'smooth' });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
      selectTab(nextTab);
      nextTab.focus();
    });
  });
  previous?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-product-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-product-thumb]')];
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    const index = thumb.dataset.productThumb;
    slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.productSlide === index));
    thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
  }));
});

document.querySelectorAll('[data-quantity]').forEach((quantity) => {
  const input = quantity.querySelector('input[type="number"]');
  const minus = quantity.querySelector('[data-quantity-minus]');
  const plus = quantity.querySelector('[data-quantity-plus]');
  if (!input) return;
  minus?.addEventListener('click', () => {
    input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  plus?.addEventListener('click', () => {
    input.value = String(Number(input.value || 1) + 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

document.querySelectorAll('[data-mobile-buy-bar]').forEach((bar) => {
  const form = document.querySelector('.eb-product-form');
  const primaryButton = form?.querySelector('.eb-add-to-cart');
  const variantSelects = [...document.querySelectorAll('[data-product-variant]')];
  const barButton = bar.querySelector('[data-mobile-buy-button]');
  const purchaseDialog = document.querySelector('[data-purchase-dialog]');
  const purchasePrice = purchaseDialog?.querySelector('[data-purchase-price]');
  const purchaseButton = purchaseDialog?.querySelector('.eb-add-to-cart');
  if (!form || !primaryButton || !barButton) return;

  const updateSelection = (source) => {
    const selected = source?.selectedOptions[0];
    if (selected) {
      variantSelects.forEach((select) => { if (select !== source) select.value = source.value; });
      if (selected.dataset.price && purchasePrice) purchasePrice.firstChild.textContent = `${selected.dataset.price} `;
      barButton.disabled = selected.disabled;
      if (purchaseButton) purchaseButton.disabled = selected.disabled;
    }
  };
  variantSelects.forEach((select) => select.addEventListener('change', () => updateSelection(select)));
  updateSelection(variantSelects[0]);

  barButton.addEventListener('click', () => {
    if (!purchaseDialog) return;
    purchaseDialog.hidden = false;
    document.documentElement.classList.add('eb-purchase-open');
    purchaseDialog.querySelector('[data-purchase-close]')?.focus();
  });
  const closePurchaseDialog = () => {
    if (!purchaseDialog) return;
    purchaseDialog.hidden = true;
    document.documentElement.classList.remove('eb-purchase-open');
    barButton.focus();
  };
  purchaseDialog?.querySelector('[data-purchase-close]')?.addEventListener('click', closePurchaseDialog);
  purchaseDialog?.addEventListener('click', (event) => { if (event.target === purchaseDialog) closePurchaseDialog(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && purchaseDialog?.hidden === false) closePurchaseDialog(); });

  const observer = new IntersectionObserver(([entry]) => {
    const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
  }, { threshold: 0 });
  observer.observe(primaryButton);
});
